import React from 'react';

import { IDBUser } from 'constants/types';

import UserIcon from '../UserIcon';
import { GroupContainer } from './styles';

interface UserIconGroupProps {
  users: IDBUser[];
  iconSize?: string;
  overlap?: string;
}

const UserIconGroup: React.FC<UserIconGroupProps> = ({
  users,
  iconSize = '24',
  overlap = '16px',
}) => (
  <GroupContainer overlap={overlap}>
    {users.map((user, index) => (
      <UserIcon
        key={index}
        userRole={user.role}
        firstName={user.firstName}
        lastName={user.lastName}
        width={iconSize}
        height={iconSize}
        marginRight="0"
      />
    ))}
  </GroupContainer>
);

export default UserIconGroup;
